import { ActionReducerMap, createReducer, on } from "@ngrx/store";
import { routerReducer } from "@ngrx/router-store";
import {
  RootStoreDataState,
  RootStoreState,
  RootStoreUiState,
  initialRootStoreDataState,
  initialRootStoreUiState,
} from "./state";
import { SubscribePageActions, UiStateActions } from "./actions";

const uiStateReducer = createReducer(
  initialRootStoreUiState,
  on(UiStateActions.setLoading, (state, { isLoading }): RootStoreUiState => ({
    ...state,
    isLoading,
  })),
  on(UiStateActions.setServerError, (state, { serverError, serverErrorEmail }):RootStoreUiState => ({
    ...state,
    serverError,
    serverErrorEmail
  }))
);

export const subscriptionReducer = createReducer(
  initialRootStoreDataState,
  on(
    SubscribePageActions.subscribeSucceeded,
    (state, { subscriptionRequest }): RootStoreDataState => {
      console.log("Updated state:", {
        ...state,
        conversationState: {
          ...state.conversationState,
          subscriptionRequest, // <-- Check if this is correctly updating
        },
      });
      return {
        ...state,
        conversationState: {
          ...state.conversationState,
          subscriptionRequest,
        },
      };
    }
  )
);
  
export const reducers: ActionReducerMap<RootStoreState> = {
  router: routerReducer,
  uiState: uiStateReducer,
  dataState: subscriptionReducer,
};


